// staff link (2026-11-04): mirror the login token into a same-origin cookie so the server can tell that a contract
// view (/documents/...) comes from someone signed in to the estimate site, and never count it as a customer open.
export function setStaffCookie(token: string | null) {
  try {
    const secure = window.location.protocol === "https:" ? "; Secure" : "";
    if (token) {
      const raw = token.replace(/^Bearer\s+/i, "");
      document.cookie = `ef_staff=${encodeURIComponent(raw)}; path=/; max-age=${30 * 24 * 3600}; SameSite=Lax${secure}`;
    } else {
      document.cookie = `ef_staff=; path=/; max-age=0; SameSite=Lax${secure}`;
    }
  } catch (e) { /* ignore */ }
}
